import { NavLink } from 'react-router';
import styled, { css } from 'styled-components';

import { Button } from '@shared/components/button';
import { BREAKPOINTS } from '@shared/styled-system';

export const Wrapper = styled.div`
	display: flex;
	align-items: stretch;
	gap: 12px;
	width: 100%;

	@media (${BREAKPOINTS.DESKTOP}) {
		width: auto;
	}
`;

export const BrandTitle = styled.div`
	display: none;
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.control.light};
	align-items: center;
	width: 100%;
	@media (${BREAKPOINTS.NOT_DESKTOP}) {
		display: flex;
	}
`;

export const PointsWrapper = styled.div<{ $isBlitz?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 4px;

	${({ $isBlitz }) =>
		$isBlitz &&
		css`
			flex-direction: row;
			align-items: center;
		`}
`;

export const Divider = styled.div`
	background-color: ${({ theme }) => theme.colors.transparent.light15};
	width: 1px;
	height: 46px;
`;

export const PointsLabel = styled.div`
	gap: 4px;
	display: inline-flex;
	align-items: center;
	color: ${({ theme }) => theme.colors.text.body};
	font-weight: 600;
	font-size: 14px;
	flex-shrink: 0;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.icon.main};

		rect {
			fill: ${({ theme }) => theme.colors.icon.main};
		}
	}
`;

export const PointsValue = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};
`;

export const DesktopAuthButton = styled.div`
	@media (${BREAKPOINTS.NOT_DESKTOP}) {
		display: none;
	}
`;

export const MobileAuthButton = styled.div<{ $isCom2?: boolean }>`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.body};
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 11px 8px 11px 0;

	svg {
		fill: ${({ theme }) => theme.colors.text.body};
	}

	${({ $isCom2, theme }) =>
		$isCom2 &&
		css`
			color: ${theme.colors.text.warning};

			svg {
				fill: ${({ theme }) => theme.colors.text.warning};
			}
		`}

	@media (${BREAKPOINTS.DESKTOP}) {
		display: none;
	}
`;

export const ProfileButton = styled(NavLink)<{ $isBlitz?: boolean }>`
	display: inline-flex;
	align-items: center;
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.body};
	gap: 6px;
	transition: all 0.2s;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.icon.secondary};
	}

	&:hover,
	&.active {
		color: ${({ theme }) => theme.colors.control.primary};
	}
`;

export const CustomAuthBtn = styled(Button)<{ $isCom2?: boolean }>`
	${({ $isCom2, theme }) =>
		$isCom2 &&
		css`
			background-color: ${theme.colors.text.warning};
		`}
`;
